import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../../../components/Navbar';
import Alerts from '../../../components/Alerts';
import IdzFileUpload from '../../../components/Veiculos/idzFileUpload';
import ReaisInput from '../../../components/ReaisInput';
import ButtonLoadingRing from '../../../components/ButtonLoading';
import api from '../../../services/apiIdz';
import { Dropdown } from 'primereact/dropdown';
import { useAuth } from '../../../context/useAuth';

function NovaImportacao() {
  const { id } = useParams();
  const navigate = useNavigate();
  const saveButton = useRef(null);
  const { token } = useAuth();

  const [formData, setFormData] = useState({
    photosUrl: [],
    brand: null,
    model: null,
    version: '',
    manufactureYear: '',
    productionYear: '',
    description: '',
    features: [],
    price: ''
  });

  const [featureInput, setFeatureInput] = useState('');
  const [sending, setSending] = useState(false);
  const [highlightImage, setHighlightImage] = useState(null);

  const [isVisible, setIsVisible] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertDescription, setAlertDescription] = useState('');
  const [alertType, setAlertType] = useState('');

  const [brandsOptions, setBrandsOptions] = useState([]);
  const [modelsOptions, setModelsOptions] = useState([]);
  const [marcasCarregadas, setMarcasCarregadas] = useState(false);

  const handleAlert = (title, description, type) => {
    setIsVisible(true);
    setAlertTitle(title);
    setAlertDescription(description);
    setAlertType(type);
  };

  useEffect(() => {
    if (isVisible) {
      setTimeout(() => setIsVisible(false), 6000);
    }
  }, [isVisible]);

  useEffect(() => {
    const getMarcas = async () => {
      try {
        const response = await api.get(`/api/marcas`, {
          headers: { Authorization: process.env.REACT_APP_API_KEY }
        });
        const lista = response.data?.map(marca => ({ label: marca.titulo, value: marca.id })) || [];
        setBrandsOptions(lista);
        setMarcasCarregadas(true);
      } catch (error) {
        console.error("Erro ao buscar marcas:", error);
        setMarcasCarregadas(true);
      }
    };
    getMarcas();
  }, []);

  const getModelos = async (marca_id) => {
    if (!marca_id) return setModelsOptions([]);
    try {
      const response = await api.get(`/api/modelos/marca/${marca_id}`, {
        headers: { Authorization: process.env.REACT_APP_API_KEY }
      });
      const lista = response.data?.map(modelo => ({ label: modelo.titulo, value: modelo.id })) || [];
      setModelsOptions(lista);
    } catch (error) {
      console.error("Erro ao buscar modelos:", error);
    }
  };

  const handleBrandChange = (e) => {
    const selectedBrand = e.value;
    handleChange('brand', selectedBrand);
    handleChange('model', null);
    getModelos(selectedBrand);
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handlePriceChange = (value) => {
    handleChange('price', value);
  };

  const handleAddFeature = (e) => {
    if (e.key === 'Enter' && featureInput.trim()) {
      e.preventDefault();
      if (!formData.features.includes(featureInput.trim())) {
        setFormData((prev) => ({
          ...prev,
          features: [...prev.features, featureInput.trim()]
        }));
        setFeatureInput('');
      }
    }
  };

  const handleRemoveFeature = (index) => {
    setFormData((prev) => ({
      ...prev,
      features: prev.features.filter((_, i) => i !== index)
    }));
  };

  const toBase64 = async (file) => {
    if (!file) return null;
    if (typeof file === 'string' && file.startsWith('data:')) return file;
    if (typeof file === 'object' && file.imagem) return file.imagem;
    if (file instanceof Blob) {
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      });
    }
    return null;
  };

  const handleUploadHighlight = async (input) => {
    const base64 = await toBase64(input);
    if (base64) setHighlightImage(base64);
  };

const handleUploadGallery = async (input) => {
  const arr = Array.isArray(input) ? input : [input];

  const novasImagens = await Promise.all(arr.map(async (item) => {
    // Caso o item já seja { src: base64 } vindo do IdzFileUpload
    if (item?.src?.startsWith('data:')) {
      return {
        imagem: item.src,
        name: 'imagem.jpg',
        type: 'image/jpeg'
      };
    }

    const base64 = await toBase64(item);
    if (!base64) return null;

    return {
      imagem: base64,
      name: item.name || 'imagem.jpg',
      type: item.type || 'image/jpeg'
    };
  }));

  const imagensValidas = novasImagens.filter(Boolean);

  setFormData(prev => {
    const atualizadas = [...(prev.photosUrl || []), ...imagensValidas];
    console.log('[DEBUG - atualizado]:', atualizadas);
    return {
      ...prev,
      photosUrl: atualizadas
    };
  });
};


const handleSubmit = async () => {
  if (saveButton.current) saveButton.current.disabled = true;
  setSending(true);

  try {
    const fotosFormatadas = formData.photosUrl.map((foto) => {
      if (foto.id) {
        return { id: foto.id, imagem: foto.imagem };
      } else {
        return { imagem: foto.imagem };
      }
    });

    const payload = {
      ...formData,
      price: parseFloat(String(formData.price).replace(/\D+/g, '')),
      photosUrl: fotosFormatadas,
      coverImage: highlightImage
    };

    const endpoint = id ? `/api/importacao/${id}` : '/api/importacao';
    const method = id ? api.put : api.post;

    const response = await method(endpoint, payload, {
      headers: {
        Authorization: process.env.REACT_APP_API_KEY,
        Token: token
      }
    });

    if (response.status === 200) {
      handleAlert('Sucesso', id ? 'Importação atualizada com sucesso.' : 'Importação cadastrada com sucesso.', 'success');
      setTimeout(() => navigate('/importacoes'), 2000);
    } else {
      handleAlert('Erro', 'Erro ao salvar importação.', 'danger');
    }
  } catch (err) {
    console.error(err);
    handleAlert('Erro', 'Erro de comunicação com servidor.', 'danger');
  } finally {
    setSending(false);
    if (saveButton.current) saveButton.current.disabled = false;
  }
};


const jaCarregou = useRef(false);

useEffect(() => {
  const getImportacao = async () => {
    if (!id || !marcasCarregadas || jaCarregou.current) return;
    jaCarregou.current = true;

    try {
      const response = await api.get(`/api/importacao/${id}`, {
        headers: { Authorization: process.env.REACT_APP_API_KEY, Token: token }
      });
      console.log("response.data", response.data)
      const data = response.data;
      
      await getModelos(data.brand);
      setFormData({
        brand: Number(data.brand),
        model: Number(data.model),
        version: data.version,
        manufactureYear: data.manufactureYear,
        productionYear: data.productionYear,
        description: data.description,
        price: data.price,
        photosUrl: (data.photosUrl || []).map(p => ({
          id: p.id,
          name: p.imagem.split('/').pop() || 'imagem.jpg',
          type: 'image/jpeg',
          imagem: p.imagem
        })),
        features: data.features || []
      });
      if (data.coverImage) setHighlightImage(data.coverImage);
    } catch (err) {
      console.error('Erro ao carregar importação:', err);
      handleAlert('Erro', 'Falha ao carregar dados da importação.', 'danger');
    }
  };

  getImportacao();
}, [id, marcasCarregadas]);


  console.log("Galeria atual:", formData.photosUrl);


  useEffect(() => {
  console.log('formData atualizado', formData.photosUrl);
}, [formData.photosUrl]);

  return (
    <>
      {isVisible && (
        <Alerts title={alertTitle} description={alertDescription} type={alertType} />
      )}
      <Navbar />
      <div className="Content PaginasNovo">
        <Container fluid>
          <Row>
            <Col xs={12}>
              <div className='HeaderPaginas'>
                <i><Icon icon="mdi:truck-import" /></i>
                <h2>Importações<br /><span>Cadastre um novo veículo importado.</span></h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <div className='NovoPaginas'>
                <Row>
                  <Col xs={12}><h3>Dados da Importação</h3></Col>

                  <Col xs={12} md={6}  className="mt-3">
                    <Form.Label className='Label'>Marca</Form.Label>
                        <Dropdown
                             filter
                            value={formData.brand}
                            options={brandsOptions}
                            onChange={handleBrandChange}
                            optionLabel="label"
                            placeholder="Selecione a marca"
                            className='Dropdown'
                        />
                  </Col>
                  <Col xs={12} md={6} className="mt-3">
                    <Form.Label className='Label'>Modelo</Form.Label>
                    <Dropdown
                      value={formData.model}
                      options={modelsOptions}
                      onChange={(e) => handleChange('model', e.value)}
                      optionLabel="label"
                      placeholder="Selecione o modelo"
                      className='Dropdown'
                    />
                  </Col>
                  <Col xs={12} md={6}  className="mt-3">
                    <Form.Label className='Label'>Versão</Form.Label>
                    <Form.Control className='Inputs' type="text" value={formData.version} onChange={(e) => handleChange('version', e.target.value)} />
                  </Col>

                  <Col xs={12} md={3} className="mt-3">
                    <Form.Label className='Label'>Ano de Fabricação</Form.Label>
                    <Form.Control className='Inputs' type="number" value={formData.manufactureYear} onChange={(e) => handleChange('manufactureYear', e.target.value)} />
                  </Col>

                  <Col xs={12} md={3} className="mt-3">
                    <Form.Label className='Label'>Ano do Modelo</Form.Label>
                    <Form.Control className='Inputs' type="number" value={formData.productionYear} onChange={(e) => handleChange('productionYear', e.target.value)} />
                  </Col>

                  <Col xs={12} className="mt-3">
                    <Form.Label className='Label'>Descrição</Form.Label>
                    <Form.Control className='Inputs' as="textarea" rows={3} value={formData.description} onChange={(e) => handleChange('description', e.target.value)} />
                  </Col>

                  <Col xs={12} md={3} className="mt-3">
                    <Form.Label className='Label'>Preço</Form.Label>
                    <ReaisInput value={formData.price} handleChange={handlePriceChange} />
                  </Col>

                  <Col xs={12} className="mt-5"><h3>Opcionais</h3></Col>
                  <Col xs={12}>
                    <Form.Label className='Label'>Características</Form.Label>
                    <Form.Control className='Inputs' type="text" value={featureInput} onChange={(e) => setFeatureInput(e.target.value)} onKeyDown={handleAddFeature} placeholder="Digite e pressione Enter" />
                    <div className='listagem mt-2'>
                      {formData.features.map((f, i) => (
                        <div key={i} className='tag'>
                          {f} <i onClick={() => handleRemoveFeature(i)}>X</i>
                        </div>
                      ))}
                    </div>
                  </Col>

                  <Col xs={12} className="mt-5"><h3>Criativos</h3></Col>
                  <Col xs={12}>
                    <Form.Label className='Label'>Imagem de Capa</Form.Label>
                    <div className='ImagesUploader'>
                      <IdzFileUpload currentFile={highlightImage} handleUpload={handleUploadHighlight} />
                    </div>
                  </Col>
                  

                  <Col xs={12}>
                    <Form.Label className='Label'>Galeria de Fotos</Form.Label>
                    <div className='ImagesUploader'>
                      <IdzFileUpload
                        multiple
                        handleUpload={handleUploadGallery}
                        currentFile={[...formData.photosUrl]}
                      />
                    </div>
                  </Col>

                  <Col xs={12} className='text-right mt-4'>
                    <Form.Group className='FormNovo'>
                      <Button className='Btns ButtonSecondary' onClick={() => navigate('/importacoes')}>Voltar</Button>
                      <Button className='Btns ButtonPrimaryLight' onClick={handleSubmit} ref={saveButton}>
                        <ButtonLoadingRing sending={sending} /> Salvar
                      </Button>
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default NovaImportacao;